import { Button, Card, Stack } from "@adfenix/alexandria";
import { TemplateUiModel } from "routes/back-office/program-builder/details/campaign/meta/template/TemplateUiModel";
import { useState } from "react";
import { Collapse } from "react-collapse";
import { Row, Col } from "react-grid-system";
import styled from "styled-components";
import { ImageTemplateContent } from "./ImageTemplateContent";
import { TemplateContent } from "./TemplateContent";
import { TemplateName } from "./TemplateName";
import { ToggleButton } from "./ToggleButton";

interface Props {
  template: TemplateUiModel;
  mode: "switch" | "add";
  onSelect: (template: TemplateUiModel) => void;
  disabled?: boolean;
}

const StyledCard = styled(Card)`
  padding: 16px;
`;

export const SelectableTemplate = ({
  template,
  mode,
  onSelect,
  disabled
}: Props) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <StyledCard>
      <Stack spacing="xs">
        <Row align="center">
          <Col
            style={{
              display: "flex",
              flexGrow: 2,
              alignItems: "center"
            }}
          >
            <TemplateName template={template} />

            <ToggleButton
              toggleMessage="View details"
              toggledMessage="Close details"
              isToggled={expanded}
              setToggle={setExpanded}
            />
          </Col>
          <Col style={{ display: "flex", justifyContent: "end" }}>
            <Button
              logLabel={`${mode}-template-button`}
              disabled={disabled ?? false}
              variant="text"
              onClick={() => onSelect(template)}
              data-testid={`${mode}-${template.name}`}
            >
              <i
                className={
                  mode === "add" ? "uil uil-plus" : "uil uil-arrow-random"
                }
              />
              {mode === "add" ? "Add" : "Switch"}
            </Button>
          </Col>
        </Row>

        <Collapse isOpened={expanded}>
          {template.type === "ad" ? (
            <TemplateContent template={template} />
          ) : (
            <ImageTemplateContent template={template} />
          )}
        </Collapse>
      </Stack>
    </StyledCard>
  );
};
